/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import firebase from 'firebase';
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import ls from "@/common/localStorage"

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
//const exhibitorRef = con.eventDB.collection(cn).doc('ExhibitorList').collection('Exhibitors');
// const photowallRef = con.eventDB.collection(cn).doc('PhotoWall').collection('Images');
const photowallRef = con.eventDB.collection(cn).doc('PhotoWall')
var GetsubcollectionsApi = con.GetsubcollectionsApi
var MailactivityApiKey = con.MailactivityApiKey;

const storageRef = con.storageRef;

export default {
    changeStatus(context, field) {
        return new Promise((resolve, reject) => {

                let totallength = field.photoList.length;
                let count = 0;
                for (var i = 0; i < field.photoList.length; i++) {
                    debugger;
                    let data = field.photoList[i]
                    //photowallRef.collection(field.AlbumName.photoDirectory).doc(`${data.PhotoWallId}`)
                    photowallRef.collection(data.photoDirectory).doc(`${data.docId}`)
                    .update({ 
                        IsPublished: field.Status,
                        LastModifiedDate: new Date()
                    }).then(function() {

                        count = count + 1;
                        if (totallength == count)
                            resolve({ status: 200, message: 'Status Changed!' })

                    })
                }
            }) // end of promise
    },
    removeSingleImage({ commit }, photoObject) {
        return new Promise((resolve, reject) => {
            //photowallRef.collection(photoObject.collectionName).doc(photoObject.docId).get().then(function(photowallDoc) {
                photowallRef.collection(photoObject.collectionName).doc(photoObject.docId).delete().then(function() {
                    let path = photoObject.photoUrl.toString().split('/PhotoWall/'+photoObject.collectionName).slice(0, -1)
                    firebase.storage().refFromURL(`${photoObject.photoUrl}`).delete().then(function() {
                        resolve({ status: 200, message: 'Rcord Deleted' })
                    })
                })
                //commit('REMOVE_SELECTEDPHOTOALBUM', PhotoWallId)
                //resolve(response)
            //})



        })
    },
    removeMultiRecords(context, field) {
        return new Promise((resolve, reject) => {
            debugger;
            let totallength = field.photoList.length;
            let collectionName = field.AlbumName;
            let count = 0;
            for (var i = 0; i < field.photoList.length; i++) {
                let PhotoWallId = field.photoList[i].PhotoWallId


                var obj = new Object();
                //obj.collectionName = collectionName.photoDirectory;
                obj.collectionName = field.photoList[i].photoDirectory;
                obj.PhotoWallId = PhotoWallId;
                obj.docId = field.photoList[i].docId;
                obj.photoUrl = field.photoList[i].photoUrl;

                context.dispatch('removeSingleImage', obj).then(value => {
                    count = count + 1;
                    if (totallength == count)
                        resolve({ status: 200, message: 'Total ' + count + ' Rcords Deleted' })
                })
            }
        })
    },
    fetchSinglePhotoAlbum({ commit }, id) {
        debugger;
        return new Promise((resolve, reject) => {
            const markers = []
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        photoUrls: [],
                        photoDirectory: ''
                    }
                })
            } else {

                let docObj = new Object

                var albumRef = con.eventDB.collection(cn)
                    .doc("PhotoWall")
                    .collection(id);

                albumRef.get().then((querySnapshot) => {
                    if (querySnapshot.docs.length > 0) {

                        querySnapshot.forEach((doc) => {
                            docObj = doc.data();
                            // console.log(doc.data());
                            markers.push({
                                PhotoWallId: doc.id, //docObj.PhotoWallId,
                                photoUrl: docObj.photoUrl,
                                IsPublished: docObj.IsPublished,
                                CreatedBy: docObj.CreatedBy,
                                CreatedDate: docObj.CreatedDate
                            })

                        })

                    }
                    debugger;
                    commit('SET_SELECTEDPHOTOALBUM', markers)
                    resolve({ status: 200, data: markers })
                }).catch(function(error) {
                    //console.log('Error getting mapped attendee:', error)
                    reject(error)
                })




                // photowallRef.doc(`${id}`).get().then(function(doc) {
                //     debugger;
                //     docObj = doc.data()
                //     console.log(docObj);
                //     // markers.push({

                //     //     photoUrl: docObj.photoUrl

                //     // })



                //     commit('SET_SELECTEDPHOTOALBUM', markers)
                //     resolve({ status: 200, data: docObj })
                // }).catch(function(error) {
                //     //console.log('Error getting mapped attendee:', error)
                //     reject(error)
                // })
            }

        })
    },
    fetchPhotowallAlbum({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            debugger;

            var path = "/" + cn + "/PhotoWall";
            var requestData = {
                path: path, // "/OA_UAT_C1591904892446E1591907102804/PhotoWall",
            };
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            const headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`,
                "apikey": MailactivityApiKey
            }


            /*var hostUrl = location.host.toLowerCase();
            var apiUrl = "";
            if (hostUrl.includes("localhost")) {
                apiUrl =
                    "https://us-central1-uate2monair.cloudfunctions.net/app/api/getsubcols";
            } else {
                if (hostUrl.includes("uat")) {
                    apiUrl =
                        "https://us-central1-uate2monair.cloudfunctions.net/app/api/getsubcols";
                } else {
                    apiUrl =
                        "https://us-central1-e2monair.cloudfunctions.net/app/api/getsubcols";
                }
            }*/


            axios.post(GetsubcollectionsApi, requestData, { headers: headers })
                .then((response) => {

                    response.data.forEach(element => {
                        markers.push({

                            photoDirectory: element

                        })
                    });

                    commit('SET_PHOTOWALLS', markers)
                    resolve(markers)
                })
                .catch((error) => { reject(error) })




        })
    },
    fetchPhotowallDirectories(context){
         return new Promise((resolve, reject) => {
            const markers = []
            var path = "/" + cn + "/PhotoWall";
            var requestData = {
                path: path, //"/OA_UAT_C1591904892446E1591907102804/PhotoWall",
            };
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            const headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`,
                "apikey": MailactivityApiKey
            }


            /*var hostUrl = location.host.toLowerCase();
            var apiUrl = "";
            if (hostUrl.includes("localhost")) {
                apiUrl =
                    "https://us-central1-uate2monair.cloudfunctions.net/app/api/getsubcols";
            } else {
                if (hostUrl.includes("uat")) {
                    apiUrl =
                        "https://us-central1-uate2monair.cloudfunctions.net/app/api/getsubcols";
                } else {
                    apiUrl =
                        "https://us-central1-e2monair.cloudfunctions.net/app/api/getsubcols";
                }
            }*/

            axios.post(GetsubcollectionsApi, requestData, { headers: headers })
                .then((response) => {
                    if(response)
                    {
                        response.data.forEach(element => {
                            markers.push(element) 
                        })
                        resolve(markers)
                    }
                    else
                    {
                        markers.push("General")
                        resolve(markers)
                    }                    
                }).catch((error) => { 
                    markers.push("General")
                    resolve(markers) 
                })
        })
    },
    fetchPhotowalls(context, field) {
        /* return new Promise((resolve, reject) => {
             const markers = []
             photowallRef.collection("Photo Album2").get().then(querySnapshot => {
                     querySnapshot.docs.forEach(doc => {
                         markers.push(doc.data())
                     })
                     commit('SET_PHOTOWALLS', markers)
                     resolve(markers)
                 })
                 .catch(function(error) {
                     //console.log('Error getting attendee:', error)
                     reject(error)
                 })

         })*/
        return new Promise((resolve, reject) => {
            const markers = []
            var path = "/" + cn + "/PhotoWall";
            var requestData = {
                path: path, //"/OA_UAT_C1591904892446E1591907102804/PhotoWall",
            };
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            const headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`,
                "apikey": MailactivityApiKey
            }


            /*var hostUrl = location.host.toLowerCase();
            var apiUrl = "";
            if (hostUrl.includes("localhost")) {
                apiUrl =
                    "https://us-central1-uate2monair.cloudfunctions.net/app/api/getsubcols";
            } else {
                if (hostUrl.includes("uat")) {
                    apiUrl =
                        "https://us-central1-uate2monair.cloudfunctions.net/app/api/getsubcols";
                } else {
                    apiUrl =
                        "https://us-central1-e2monair.cloudfunctions.net/app/api/getsubcols";
                }
            }*/

            
            /*axios.post(GetsubcollectionsApi, requestData, { headers: headers })
                .then((response) => {
                    let count = 0;
                    let totallength = response.data.length
                    console.log(totallength)
                    if(totallength)
                    {*/
                        //response.data.forEach(element => {
                            let status = field.status ? field.status : true
                            let directory = field.directory ? field.directory : 'General'
                            photowallRef.collection(directory).orderBy("LastModifiedDate", "desc").get().then(querySnapshot => {
                                 querySnapshot.docs.forEach(doc => {
                                    let docObj = doc.data()
                                    docObj.docId = doc.id
                                    docObj.photoDirectory = directory
                                    if(status == 'Publish')
                                    {
                                        if(docObj.IsPublished == true)
                                            markers.push(docObj)
                                    }
                                    else if(status == 'Unpublish')
                                    {
                                        if(docObj.IsPublished == false)
                                            markers.push(docObj)
                                    }
                                    else
                                    {
                                        markers.push(docObj)                                    
                                    }
                                 })  
                                /* count = count + 1; 
                                if(totallength == count)
                                {*/
                                    context.commit('SET_PHOTOWALLS', markers)
                                    resolve(markers)
                                //}                         
                             })                        
                        //});      
                    /*}  
                    else
                    {
                        context.commit('SET_PHOTOWALLS', markers)
                            resolve(markers)
                    } */           
                //}).catch((error) => { reject(error) })





        })
    },
    fetchPhotowall(context, directory) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (directory) {
                let photoUrls = []
                photowallRef.collection(directory).orderBy("LastModifiedDate").get().then(querySnapshot => {
                    querySnapshot.docs.forEach(doc => {
                        photoUrls.push(doc.data().photoUrl)
                    })
                    resolve({
                    status: 200,
                    data: {
                        photoUrls: photoUrls,
                        photoDirectory: directory,
                        photoDirectoryDisable: true
                    }
                    })
                })
            }
            else{
                resolve({
                    status: 200,
                    data: {
                        photoUrls: [],
                        photoDirectory: 'General',
                        photoDirectoryDisable: false
                    }
                })
            }
        })
    },

    updatePhotowall(context, field) {
        return new Promise((resolve, reject) => {
            exhibitorRef.doc(`${field.id}`).update({
                    BoothNo: field.data.BoothNo,
                    Category: field.data.Category,
                    Email: field.data.Email,
                    HotspotImageURL: field.data.HotspotImageURL,
                    LastModifiedDate: new Date(),
                    Logo: field.data.Logo,
                    MappedContacts: field.data.MappedContacts ? field.data.MappedContacts : [],
                    Name: field.data.Name,
                    Phone: field.data.Phone,
                    Profile: field.data.Profile,

                    //Resources:[],
                    ShowcaseImages: [],

                    ShowcaseVideoURL: field.data.ShowcaseVideoURL,
                    // SocialLinks:[          
                    //   {Facebook:field.data.SocialLinks.Facebook},
                    //   {Twitter:field.data.SocialLinks.Twitter},
                    //   {GooglePlus:field.data.SocialLinks.GooglePlus},
                    //   {LinkedIn:field.data.SocialLinks.LinkedIn}
                    // ],
                    Website: field.data.Website
                })
                .then(function(doc) {
                    context.dispatch('resourceUpload', { Id: field.id, files: field.data.ResourceFiles }).then(resource => {
                        if (field.data.file) {
                            const file = field.data.file
                            const metadata = {
                                'contentType': file.type
                            }
                            storageRef.child(`${cn  }/Exhibitor/profileImage/${  new Date().getTime()  }_${  file.name}`).put(file, metadata).then(function(snapshot) {
                                snapshot.ref.getDownloadURL().then(function(url) {
                                    exhibitorRef.doc(`${field.id}`).update({ Logo: url.toString() }).then(function(doc) {
                                        resolve({ status: 200, message: 'Data & File Updated.' })
                                    })
                                })
                            })
                        } else {
                            resolve({ status: 200, message: 'Data Updated.' })
                        }
                    })

                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    },

    addPhotowall(context, field) {
        //console.log(field); 
        return new Promise((resolve, reject) => {
            let UserName = window.localStorage.getItem("Name");
            let docObj = {
                photoUrl: '',
                photoDirectory: field.data.photoDirectory,
                CreatedBy: UserName,
                CreatedDate: new Date(),
                LastModifiedDate: new Date(),
                PhotoWallId: null,
                IsPublished: false
            }
            context.dispatch('getAutoId').then(PhotoWallId => {
                docObj.PhotoWallId = PhotoWallId;

                if (field.data.ResourceFiles && field.data.ResourceFiles.length) {

                    let count = 0;
                    for (var i = 0; i < field.data.ResourceFiles.length; i++) {
                        let file = field.data.ResourceFiles[i]
                        let fileName = file.name.split('.').slice(0, -1).join('.').toLowerCase();
                        let metadata = { 'contentType': file.type }

                        photowallRef.collection(`${docObj.photoDirectory}`).doc(`${fileName + docObj.PhotoWallId}`).set(docObj).then(function() {

                            storageRef.child(`${cn}/PhotoWall/${docObj.photoDirectory}/${new Date().getTime()  }_${  file.name}`).put(file, metadata).then(function(snapshot) {
                                snapshot.ref.getDownloadURL().then(function(url) {
                                    let urlString = url.toString().split('&token').slice(0, -1).join('.')
                                    photowallRef.collection(`${docObj.photoDirectory}`).doc(fileName + docObj.PhotoWallId).update({ photoUrl: urlString }).then(function(doc) {
                                        count = count + 1;
                                        if (field.data.ResourceFiles.length == count)
                                            resolve({ status: 200, message: 'Files Updated.' })
                                    })
                                })
                            })

                        }).catch(function(error) {
                            reject(error)
                        })

                    }

                } else {
                    resolve({ status: 200, message: 'Files Updated.' })
                }


            });


        })
    },

    async getAutoId(context) {
        let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function(doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function() {
                        con.instanceDB.doc("AutoID").get().then(function(doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })
        AutoId = await promise;
        AutoId = AutoId * 1000;
        return AutoId.toString();
    },
    upload_resizePhoto(context, field){
        return new Promise((resolve, reject) => {
            storageRef.child(`${cn}/PhotoWall/${field.photowall_data.photoDirectory}/${new Date().getTime()  }_${  field.name}`).putString(field.data_url, 'data_url').then(function(snapshot) {
                snapshot.ref.getDownloadURL().then(function(url) {
                    photowallRef.collection(`${field.photowall_data.photoDirectory}`).doc(field.photowall_data.docId).update({ 
                            photoUrl: url.toString(),
                            LastModifiedDate: new Date()
                        }).then(function(doc) {
                            resolve({ status: 200, message: 'Files Updated.' })
                    })
                })
            })
        })
    },
    photoUpload(context, obj) {
        return new Promise((resolve, reject) => {
            if (obj.files && obj.files.length) {
                let count = 0;
                for (var i = 0; i < obj.files.length; i++) {
                    let file = obj.files[i]
                    let metadata = {
                        'contentType': file.type
                    }
                    storageRef.child(`${cn}/PhotoWall/${obj.photoDirectory}/${new Date().getTime()  }_${  file.name}`).put(file, metadata).then(function(snapshot) {
                        snapshot.ref.getDownloadURL().then(function(url) {
                            photowallRef.collection(`${obj.photoDirectory}`).doc().update({ photoUrls: firebase.firestore.FieldValue.arrayUnion(url.toString()) }).then(function(doc) {
                                count = count + 1;
                                if (obj.files.length == count)
                                    resolve({ status: 200, message: 'Files Updated.' })
                            })
                        })
                    })
                }
            } else {
                resolve({ status: 200, message: 'Files Updated.' })
            }
        })
    },

    removeRecord({ commit }, userId) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/user-management/users/${userId}`)
                .then((response) => {
                    commit('REMOVE_RECORD', userId)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    }
}